/* eslint-disable no-param-reassign */
import React, { useContext, useMemo } from 'react';

import events from 'utilities/amplitude/events';
import { getCropZonesFromProperties } from 'helpers/propertyHelpers';
import Button from 'screens/Integrations/components/IntegrationButton';
import { useHistory } from 'react-router-dom';

import { paths } from 'routes/paths';
import useSubmissionUrlHandler from 'screens/Integrations/hooks/useSubmissionUrlHandler';
import useSubmissionAnalytics from 'screens/Integrations/hooks/useSubmissionAnalytics';
import StepCard from 'screens/Integrations/components/StepCard';

import { SubmissionSummaryContext } from '../../context/SubmissionSummaryProvider';
import IconByStatus from './components/IconByStatus';
import TextByStatus from './components/TextByStatus';

const SuccessPage = () => {
  const {
    state: { integrationType, farms, submissionId, submissionResult }
  } = useContext(SubmissionSummaryContext);

  const { comingFromView } = useSubmissionUrlHandler();

  const history = useHistory();

  const tasksLength = useMemo(() => {
    const cropzones = getCropZonesFromProperties(farms);
    return [
      ...new Map(
        cropzones?.flatMap(cropzone =>
          cropzone.tasks?.map(task => [task.taskId, task])
        )
      ).values()
    ].length;
  }, [farms]);

  useSubmissionAnalytics({
    onMountTriggerEvent: {
      event: events.epic.Integrations.submissionCompleted,
      data: { vendor: integrationType, tasksLength, submissionId }
    }
  });

  const handleRedirectToHistoryPage = () => {
    return history.push(
      `${paths.integrations}/${integrationType}/landing-page`
    );
  };

  return (
    <StepCard size="full" className="h-full" testId="success-page">
      <div className="flex justify-center  flex-col h-full">
        <div className="flex text-center items-center flex-col justify-center ">
          <IconByStatus
            submissionResult={submissionResult}
            integrationType={integrationType}
          />
          <TextByStatus
            submissionResult={submissionResult}
            integrationType={integrationType}
            comingFromView={comingFromView}
          />
          <div className="flex justify-center">
            {(submissionResult?.httpStatusCode === 207 ||
              submissionResult?.httpStatusCode === 422) && (
              <div className="mr-2">
                <a
                  href={`${paths.integrations}/${integrationType}/submission/${submissionResult.id}`}
                  rel="noreferrer"
                >
                  <Button id="return-viewpage-button" variant="primary">
                    View Submission Details
                  </Button>
                </a>
              </div>
            )}
            <Button
              id="return-mainpage-button"
              variant={
                submissionResult?.httpStatusCode === 207 ||
                submissionResult?.httpStatusCode === 422
                  ? 'outline'
                  : 'primary'
              }
              onClick={handleRedirectToHistoryPage}
            >
              Go to Submissions History
            </Button>
          </div>
        </div>
      </div>
    </StepCard>
  );
};

export default SuccessPage;
